import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 15h16a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4","key":"svg-0"}],["path",{"d":"M12 4c3.783 0 6.953 2.133 7.786 5h-15.572c.833 -2.867 4.003 -5 7.786 -5","key":"svg-1"}],["path",{"d":"M5 12h14","key":"svg-2"}]]

const IconBurger = createReactComponent('outline', 'burger', 'Burger', __iconNode);

export default IconBurger;